import mutations from "@/store/modules/chat/mutations";
import getters from "@/store/modules/chat/getters";
import actions from "@/store/modules/chat/actions";
import { CHAT_TYPE } from "@/resources/constants/chat";
const state = {
  chatType: CHAT_TYPE.ONE_TO_ONE,
  userChat: null,
  chatRoomId: null,
  messagingSession: null,
  endPointUrl: null,
  messages: [],
  unSeenMessages: [],
  nextToken: null,
  minimizeChat: (JSON.parse(localStorage.getItem("config")) && JSON.parse(localStorage.getItem("config")).chat && JSON.parse(localStorage.getItem("config")).chat.openRoomChatByDefault) ? JSON.parse(localStorage.getItem("config")).chat.openRoomChatByDefault : false,
  pinnedMessagesLength: 0,
};
export type State = typeof state;

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
